import Home from './Home';
import ErrorBoundary from '@/components/ErrorBoundary';
import { QueryClient, QueryClientProvider } from '@umijs/max';
// import wx from 'weixin-js-sdk';

import styles from './index.less';
// import { Route } from '../../config/route';

// import { queryLogin } from '@/service';
// import qs from 'qs';
// import md5 from 'js-md5';

const queryClient = new QueryClient();

export default function IndexPage() {
  // const location = useLocation();

  const fallback = () => {
    return <div>暂无数据</div>;
  };

  // const formattedTitle = (): string => {
  //   console.log(location.pathname, Route);
  //   return Route.find((item) => item.path === location.pathname)?.title || '';
  // };

  return (
    <div className={styles.content}>
      <ErrorBoundary fallback={fallback()}>
        {/*<Helmet>*/}
        {/*  <title>{formattedTitle()}</title>*/}
        {/*</Helmet>*/}
        <QueryClientProvider client={queryClient}>
          <Home />
        </QueryClientProvider>
      </ErrorBoundary>
    </div>
  );
}
